/* Tonoko — PDP. Galería + selector de pack/cantidad (costo por página, ahorro, total)
   + agregar al carrito por AJAX con respaldo nativo. Vanilla, defensivo. */
(function () {
  'use strict';
  var root = document.querySelector('[data-tnk-pdp]');
  if (!root) return;

  var fmt = function (n) {
    var v = Number(n);
    if (isNaN(v)) return '';
    return '$' + v.toLocaleString('es-MX', { maximumFractionDigits: 2 });
  };
  var qs = function (sel, ctx) {
    return (ctx || root).querySelector(sel);
  };
  var qsa = function (sel, ctx) {
    return Array.prototype.slice.call((ctx || root).querySelectorAll(sel));
  };

  /* ---------- Galería: miniatura -> imagen principal ---------- */
  var mainImg = qs('.pdp__main-img');
  qsa('[data-tnk-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-src');
      if (!src || !mainImg) return;
      qsa('[data-tnk-thumb]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      btn.classList.add('is-active');
      mainImg.src = src;
      mainImg.removeAttribute('srcset');
    });
  });

  /* ---------- Selector de pack / variante ---------- */
  var priceEl = qs('[data-tnk-price]');
  var unitEl = qs('[data-tnk-unit]');
  var perpageEl = qs('[data-tnk-perpage]');
  var saveEl = qs('[data-tnk-save]');
  var totalEl = qs('[data-tnk-total]');
  var variantInput = qs('[data-tnk-variant-id]');
  var qtyHidden = qs('[data-tnk-qty-hidden]');

  function selectPack(input) {
    if (!input) return;
    var d = input.dataset;
    var units = Number(d.units || 1);
    if (priceEl && d.unit) priceEl.textContent = fmt(d.unit);
    if (unitEl) unitEl.textContent = units > 1 ? 'c/u' : '';
    if (perpageEl && d.perpage) perpageEl.textContent = '$' + d.perpage;
    if (saveEl && d.save) saveEl.textContent = 'Ahorras ' + d.save + '%';
    if (totalEl && d.total) totalEl.textContent = fmt(d.total);
    if (qtyHidden) qtyHidden.value = units;
    if (variantInput && d.variant) variantInput.value = d.variant;
  }

  var packRadios = qsa('input[name="tnk-pack"]');
  if (packRadios.length) {
    packRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        selectPack(r);
      });
    });
    selectPack(
      packRadios.filter(function (r) {
        return r.checked;
      })[0] || packRadios[0],
    );
  }

  /* ---------- Cantidad (variante única) ---------- */
  var qtyInput = qs('[data-tnk-qinput]');
  function syncQty() {
    if (!qtyInput) return;
    var unit = Number(qtyInput.getAttribute('data-unit') || 0);
    var q = Math.max(1, parseInt(qtyInput.value, 10) || 1);
    qtyInput.value = q;
    if (totalEl && unit > 0) totalEl.textContent = fmt(unit * q);
  }
  if (qtyInput) {
    var dec = qs('[data-tnk-qdec]'),
      inc = qs('[data-tnk-qinc]');
    if (dec)
      dec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        syncQty();
      });
    if (inc)
      inc.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        syncQty();
      });
    qtyInput.addEventListener('change', syncQty);
    syncQty();
  }

  /* ---------- Agregar al carrito (AJAX con respaldo nativo) ---------- */
  var form = qs('[data-tnk-form]');
  var toast = document.querySelector('[data-tnk-toast]');
  var toastTimer;

  function showToast(msg) {
    if (!toast) return;
    var m = toast.querySelector('[data-tnk-toast-msg]');
    if (m && msg) m.textContent = msg;
    toast.hidden = false;
    requestAnimationFrame(function () {
      toast.classList.add('is-on');
    });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-on');
      setTimeout(function () {
        toast.hidden = true;
      }, 250);
    }, 3500);
  }

  function refreshCartBubble() {
    // Mejora opcional: actualizar el número del carrito sin recargar.
    // Solo se escribe texto (textContent), nunca HTML, para evitar cualquier riesgo XSS.
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        var nodes = Array.prototype.slice.call(
          document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"], [data-tnk-cart-count]'),
        );
        nodes.forEach(function (n) {
          n.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  if (form && window.fetch && window.FormData) {
    form.addEventListener('submit', function (e) {
      var addBtn = qs('.pdp__add', form);
      if (addBtn && addBtn.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      var fd = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: fd,
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          showToast('✓ Agregado al carrito');
          refreshCartBubble();
        })
        .catch(function () {
          // Respaldo: envío nativo del formulario (va a /cart).
          form.submit();
        });
    });
  }
})();
